/**
 * Цвет-акцент обличия в коллекции, лобби и окнах наград (ключ PLAYER_COLORS,
 * в hex его переводит resolveFactionColor).
 *
 * Обычно это первый приоритетный цвет образа, а у образа без своих цветов —
 * первый цвет фракции. Поле accentColor в конфиге образа задает акцент
 * отдельно от цвета на поле: у рубинового наследия ({factionId}_ruby_legacy)
 * акцент — красный цвет рубиновой лиги, а на поле игрок первым получает
 * другой цвет (красный там плохо читается на тайлах городов).
 *
 * @param {Object|undefined} skin - конфиг образа (или его копия с теми же полями)
 * @param {Object|undefined} faction - конфиг фракции образа
 * @returns {string|undefined} ключ цвета
 */
export const getFactionSkinAccentColorKey = (skin, faction) => skin?.accentColor
  || skin?.colors?.[0]
  || faction?.colors?.[0];
